import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Box, Stack, Typography, Button } from '@mui/material';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import AddIcon from '@mui/icons-material/Add';
import { TableV2, CustomFilterV2 } from '../../../components/v2';
import * as selectorsAlimentadores from '../../../store/alimentador/reducer';
import * as actionsAlimentadores from '../../../store/alimentador/actions';
import Formulario from './Formulario';

const Alimentadores = ({ alimentadores, loadAlimentadores, deleteAlimentador }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);
  const [localFilter, setLocalFilter] = useState({});

  useEffect(() => {
    loadAlimentadores();
  }, [loadAlimentadores]);

  const columns = [
    { field: 'codigo', headerName: 'Código', flex: 0.4 },
    { field: 'nome', headerName: 'Nome', flex: 1 },
    {
      field: 'subestacaoCodigos',
      headerName: 'Subestações',
      flex: 0.8,
      renderCell: (params) => {
        const val = params.row.subestacaoCodigos;
        return val && Array.isArray(val) ? val.join(', ') : '';
      },
    },
  ];

  return (
    <Box>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
        >
          <Typography variant="h4">Alimentadores</Typography>
          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <TableV2
          rows={alimentadores}
          columns={columns}
          onEdit={id => { setOpen(true); setId(id); }}
          onDelete={id => deleteAlimentador(id)}
          headerActions={[
            { label: 'Novo', onClick: () => { setOpen(true); setId(null); }, startIcon: <AddIcon />, variant: 'contained' },
          ]}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          appliedFilter={localFilter}
          fields={[
            { field: 'useCodigo' },
            { field: 'useMalha' },
            { field: 'useGerencia' },
            { field: 'usePolo' },
            { field: 'useSubestacao' },
          ]}
          onFilter={filterData => {
            setLocalFilter(filterData);
            loadAlimentadores(filterData);
            setOpenFilter(false);
          }}
        />

        <Formulario
          id={id}
          open={open}
          onClose={isSave => {
            setOpen(false);
            setId(null);
            if (isSave) loadAlimentadores();
          }}
          alimentadores={alimentadores}
        />
      </Stack>
    </Box>
  );
};

Alimentadores.propTypes = {
  deleteAlimentador: PropTypes.func.isRequired,
  loadAlimentadores: PropTypes.func.isRequired,
  alimentadores: PropTypes.array,
};

const mapStateToProps = state => ({
  alimentadores: selectorsAlimentadores.getAlimentadores(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsAlimentadores
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Alimentadores));
